module.exports = __webpack_public_path__ + "114f54e67c03474d70bd8443f0a21c55.jpg";